/**
 * GMA-1628 (CompassCare Web 13/14) — Schedule route container.
 *
 * Mounts the app-shell (WebShell) around the Schedule / Activities screen
 * (SchedulePage) at /web/schedule, wiring sidebar navigation to the router
 * and the "Run Activity Report" handoff to the Reports hub (GMA-1626). This
 * is the route scaffolding: the live activity feed (real per-client
 * activities from the API) is a deliberate follow-up, so until then the page
 * renders the demo schedule in demo builds and its fail-safe empty states
 * otherwise, inside a real, navigable frame.
 */
import React from "react";
import { useNavigate } from "react-router-dom";
import WebShell from "../../components/web/WebShell";
import SchedulePage from "./SchedulePage";
import { DEMO_DATA_ENABLED, getDemoSchedule } from "./demoData";

export default function WebScheduleRoute() {
  const navigate = useNavigate();
  // Capture one timestamp so the demo dataset and the `now` prop agree —
  // status derivation drifts if each call reads the clock separately.
  const now = Date.now();
  const demo = DEMO_DATA_ENABLED ? getDemoSchedule(now) : null;
  return (
    <WebShell
      activeKey="schedule"
      onNavigate={(section) => {
        if (section && section.path) navigate(section.path);
      }}
      title="Schedule"
    >
      <SchedulePage
        clients={demo ? demo.clients : []}
        days={demo ? demo.days : []}
        defaultDayId={demo ? demo.defaultDayId : undefined}
        now={now}
        onRunActivityReport={() => navigate("/web/reports")}
      />
    </WebShell>
  );
}
